<template>
  <div class="flex grow-0">
    <lf-pill
      v-if="statusDescription"
      :color-index="colorIndex"
      class="h-[24px] font-bold whitespace-nowrap uppercase"
      size="sm"
    >
      {{ statusDescription }}
    </lf-pill>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { STATUS_COLOR_CODES, WORKFLOW_DATA_CAPTURE } from "@/helpers/constants";

import type { IApplication } from "@/models/applications";
import type { IOffer } from "@/models/funders";
import type { PropType } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  model: {
    type: Object as PropType<IApplication>,
    default: null,
  },
  dealType: {
    type: String,
    default: "",
  },
});

const { t } = useI18n();

const instanceOfOffer = (data: IApplication | IOffer): data is IOffer => {
  return !!data && "application" in data;
};

const statusDescription = computed(() => {
  if (
    props.dealType === WORKFLOW_DATA_CAPTURE ||
    (!instanceOfOffer(props.model) &&
      props.model?.status_description === "Approved")
  ) {
    return t("APPLICATION_STAGES.COMPLETE");
  }

  return props.model?.status_description || "";
});
const colorIndex = computed(
  () =>
    STATUS_COLOR_CODES[
      (props.modelValue as keyof typeof STATUS_COLOR_CODES) || 0
    ]
);
</script>
